"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _epitelete = _interopRequireDefault(require("epitelete"));

var _perf2html = _interopRequireDefault(require("./perf2html"));

var _html2perf = _interopRequireDefault(require("./html2perf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class EpiteletePerfHtml extends _epitelete.default {
  constructor(_ref) {
    var {
      proskomma = null,
      docSetId,
      htmlMap,
      options = {}
    } = _ref;
    super({
      proskomma,
      docSetId,
      options
    });
    this.htmlMap = htmlMap;
  }

  _outputHtml(doc) {
    var sequencesHtml = Object.keys(doc.sequences).reduce((sequences, seqId) => {
      sequences[seqId] = (0, _perf2html.default)(doc, seqId, this.htmlMap);
      return sequences;
    }, {});
    return {
      docSetId: this.docSetId,
      mainSequenceId: doc.main_sequence_id,
      schema: doc.schema,
      metadata: doc.metadata,
      sequencesHtml
    };
  }

  readHtml(bookCode) {
    var _this = this;

    return _asyncToGenerator(function* () {
      return _this._outputHtml(yield _this.readPerf(bookCode));
    })();
  }

  undoHtml(bookCode) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      return _this2._outputHtml(yield _this2.undoPerf(bookCode));
    })();
  }

  redoHtml(bookCode) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      return _this3._outputHtml(yield _this3.redoPerf(bookCode));
    })();
  }

  writeHtml(bookCode, sequenceId, perfHtml) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      var perf = (0, _html2perf.default)(perfHtml, sequenceId);
      yield _this4.writePerf(bookCode, sequenceId, perf);
      return yield _this4.readHtml(bookCode);
    })();
  }

}

var _default = EpiteletePerfHtml;
exports.default = _default;